var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#366EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09863 13H7.11621V6H9.09863V13ZM7 3.68945C7 3.39323 7.09798 3.14941 7.29395 2.95801C7.49447 2.7666 7.76562 2.6709 8.10742 2.6709C8.44466 2.6709 8.71354 2.7666 8.91406 2.95801C9.11458 3.14941 9.21484 3.39323 9.21484 3.68945C9.21484 3.99023 9.1123 4.23633 8.90723 4.42773C8.70671 4.61914 8.4401 4.71484 8.10742 4.71484C7.77474 4.71484 7.50586 4.61914 7.30078 4.42773C7.10026 4.23633 7 3.99023 7 3.68945Z",
    fill: "#366EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.04315dd4cd0dcc6167221f0cebc65e4b.svg";
export { ForwardRef as ReactComponent };